import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PreviewModalComponent} from "../preview-modal/preview-modal.component";
import {ShareService} from "../../services/share.service";
import {ValidationService} from "../../services/validation.service";
import {ConverterService} from "../../services/converter.service";
import {DeviceDataService} from "../../services/device-data.service";
import {Dialog} from "@angular/cdk/dialog";

@Component({
  selector: 'app-navigation-footer',
  templateUrl: './navigation-footer.component.html',
  styleUrls: ['./navigation-footer.component.scss']
})
export class NavigationFooterComponent implements OnInit {
  @Input() backLink: string = '';
  @Input() isBackLinkDisabled: boolean = false;
  @Input() nextLink: string = '';
  @Input() isNextLinkDisabled: boolean = false;
  @Input() isLast: boolean = false;

  @Output() validate = new EventEmitter<void>();

  constructor(
    private shareService: ShareService,
    public validationService: ValidationService,
    private converterService: ConverterService,
    private deviceDataService: DeviceDataService,
    private dialog: Dialog
  ) {
  }

  ngOnInit(): void {
  }

  public async showPreviewPopup() {
    console.log('onShowPreviewBtnClickedNew');
    if (this.shareService.isMqttBlocked) {
      return;
    }

    if (!(await this.validationService.isSelectedSiteStillValid())) {
      return;
    }

    if (this.shareService.debugMode) {
      // console.error('onShowPreviewBtnClicked - shaftContact2On:', this.shareService.collectedData.shaftContact2On);
      // console.log(
      //   "onShowPreviewBtnClicked - collectedDataStringify:",
      //   JSON.stringify(this.shareService.collectedData)
      // );
      // console.log(
      //   "onShowPreviewBtnClicked - collectedData:",
      //   this.shareService.collectedData
      // );

      // if (installGatewayComponent.temperatureSensors?.length)  {
      //     installGatewayComponent.updateGatewayWithSensorData();
      //     console.log('gateway with sensors from tables:', this.gateway);
      //     console.log('gateway with sensors from tables - json:', JSON.stringify(this.gateway));
      // } else {
      //     installGatewayComponent.updateGatewayWithSensorData();
      // }
    }

    const deviceData = this.deviceDataService.getDeviceData().deviceData;
    if (deviceData) {
      this.converterService.updateCollectedDataWithValues(deviceData);
    }

    if (this.validationService.isCollectedDataValid()) {
      this.dialog.open(PreviewModalComponent, {
        data: {
          deviceData: deviceData
        }
      })
    }

    if (this.shareService.debugMode) {
      console.log("gateway:", JSON.stringify(this.shareService.getDataForConsoleLog));
      console.log("gateway:", this.shareService.getDataForConsoleLog);
    }
  }

}
